<section id="header" class="row form-inline">
  <div class="col-auto input-group">
    <button
      type="button"
      class="btn btn-sm btn-primary"
      [routerLink]="[ADD_ROUTE]"
      [innerHtml]="'+&nbsp;' + ('Contract.add' | translate)"
    ></button>
  </div>
  <app-contracts-filters class="row col" [filterData]="filters" (filterDataChange)="onDataFilterChange($event)" />
</section>
<section class="card">
  <div *ngIf="contracts.length > 0" class="table-responsive">
    <table class="table table-striped table-condensed">
      <thead>
        <tr>
          <th>{{ 'Contract.name' | translate }} / {{ 'Contract.number' | translate }}</th>
          <th [innerHtml]="'Contract.holder' | translate"></th>
          <th [innerHtml]="'Contract.type' | translate"></th>
          <th [innerHtml]="'Contract.nbActiveSites' | translate"></th>
          <th [innerHtml]="'Contract.nbSites' | translate"></th>
          <th [innerHtml]="'Contract.nbClusters' | translate"></th>
          <th [innerHtml]="'Contract.millionRequestsPerMonth' | translate"></th>
          <th [innerHtml]="'Contract.nbOrganizations' | translate"></th>
          <th [innerHtml]="'Contract.startDate' | translate"></th>
          <th [innerHtml]="'Contract.renewDate' | translate"></th>
          <th class="actions" [innerHtml]="'Actions' | translate"></th>
        </tr>
      </thead>
      <tbody>
        <ng-template
          ngFor
          let-item
          [ngForOf]="
            contracts | paginate: { itemsPerPage: pageSize, currentPage: page, totalItems: totalItems }
          "
        >
          <tr>
            <td>
              <a [routerLink]="[item.number]"><b>{{ item.name }}</b></a> <app-badge-organization [code]="item.number"></app-badge-organization>
            </td>
            <td>
              <a [routerLink]="['/',ADMIN_PREFIX,ORGANIZATIONS_ROUTE,item.holder.code]">{{ item.holder.name }}</a>
              <app-badge-organization [code]="item.holder.code"></app-badge-organization>
            </td>
            <td>
              <ng-container *ngIf="item.type">{{ 'Contract.typeEnum.' + item.type | translate }}</ng-container>
            </td>
            <td class="number">{{ item.nbInvoicedSites }}/{{ item.nbSites || '—' }}</td>
            <td class="number">{{ item.nbTotalSites }}</td>
            <td class="number">{{ item.nbInvoicedClusters }}</td>
            <td class="number">{{ item.millionRequestsPerMonth }}</td>
            <td class="number">{{ item.nbOrganizations }}</td>
            <td>
              <app-timestamp-cell [value]="item.startDate"></app-timestamp-cell>
            </td>
            <td>
              <app-timestamp-cell [value]="item.renewalDate"></app-timestamp-cell>
            </td>
            <td class="actions">
              <a [routerLink]="[item.number]"> <i class="icofont icofont-edit-alt" title="Editer"></i></a>
              <a [routerLink]="[item.number, 'invoicing-report']">
                <i class="icofont icofont-chart-bar-graph" [title]="'Contract.consumptionReport' | translate"></i
              ></a>
              <i (click)="modalRemove(item)" class="icofont icofont-ui-delete" title="Supprimer"></i>
            </td>
          </tr>
        </ng-template>
      </tbody>
    </table>
    <div class="float-right mr-2">
      <pagination-controls
        class="pull-right"
        (pageChange)="changePage($event)"
        previousLabel="{{ 'Previous' | translate }}"
        nextLabel="{{ 'Next' | translate }}"
      />
      <div class="pull-right mr-4 total-admin">Total : {{ totalItems }}</div>
    </div>
  </div>
  <div *ngIf="contracts.length == 0">{{ 'Contract.none' | translate }}</div>
</section>

<!-- POPUP REMOVE contract -->
<app-modal-basic #remove [dialogClass]="'modal-md'">
  <div class="app-modal-header">
    <h4 class="modal-title">
      <small [innerHtml]="'Confirmation'"></small>
    </h4>
  </div>
  <div class="app-modal-body">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label class="label label-primary">{{ 'Contract.number' | translate }}</label>
          <p>{{ contract?.number }}</p>
        </div>
        <div class="form-group">
          <label class="label label-primary">{{ 'Contract.holder' | translate }}</label>
          <p>{{ contract?.holder?.name }} / {{ contract?.holder?.code }}</p>
        </div>
      </div>
    </div>
  </div>
  <div class="app-modal-footer">
    <button (click)="removeContract(contract?.number)" class="btn btn-sm btn-primary" [innerHtml]="'Supprimer'"></button
    >&nbsp;
    <button (click)="remove.hide()" class="btn btn-sm btn-danger" [innerHtml]="'Annuler'"></button>
  </div>
</app-modal-basic>
